<div class="w-full overflow-y-auto h-full">
    <div class="w-full p-6">
        <!-- Loading State - Skeleton -->
        <div *ngIf="isLoading" class="w-full">
            <div class="w-full py-6">
                <!-- Título -->
                <div class="h-6 bg-gray-300 rounded-xl w-40 ml-4 mb-4 animate-pulse"></div>

                <!-- Linhas -->
                <div class="w-full p-4 space-y-3">
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                </div>
            </div>

            <div class="w-full py-6 border-t border-gray-200">
                <!-- Título -->
                <div class="h-6 bg-gray-300 rounded-xl w-48 ml-4 mb-4 animate-pulse"></div>

                <!-- Linhas -->
                <div class="w-full p-4 space-y-3">
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && !clientData && !billingAddress" class="flex flex-col items-center justify-center py-12 text-gray-400">
            <mat-icon svgIcon="heroicons_outline:inbox" class="w-12 h-12 mb-4"></mat-icon>
            <p class="font-inter text-[14px]">Nenhum dado de cobrança disponível</p>
        </div>

        <!-- Dados de Cobrança -->
        <ng-container *ngIf="!isLoading && (clientData || billingAddress)">
            <!-- Dados da Igreja -->
            <div class="w-full py-6">
                <div class="flex w-full justify-between items-center">
                    <div class="flex">
                        <div class="p-2 rounded-xl bg-orange-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:business" class="icon-size-6 text-orange-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Dados da igreja</span>
                            </div>
                        </div>
                    </div>
                    <button mat-icon-button class="w-8 h-8">
                        <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'mat_outline:edit'"></mat-icon>
                    </button>
                </div>
                <div class="w-full p-4">
                    <!-- Nome da igreja -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Nome da igreja</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(clientData?.name) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- CNPJ -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">CNPJ</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ formattedDocNumber }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Inscrição Estadual -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Inscrição Estadual</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(clientData?.stateRegistration) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Email para Notas Fiscais -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Email para Notas Fiscais</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(clientData?.invoiceEmail || clientData?.mail) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Telefone / Celular -->
                    <div class="py-4">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Telefone / Celular</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(clientData?.cellPhone) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Endereço de Cobrança -->
            <div class="w-full py-6 border-t border-gray-200">
                <div class="flex w-full justify-between items-center">
                    <div class="flex">
                        <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                            <mat-icon svgIcon="mat_solid:location_on" class="icon-size-6 text-blue-600"></mat-icon>
                        </div>
                        <div class="px-3">
                            <div class="w-full leading-10">
                                <span class="text-[17px] font-[500] font-remote">Endereço de Cobrança</span>
                            </div>
                        </div>
                    </div>
                    <button mat-icon-button class="w-8 h-8">
                        <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'mat_outline:edit'"></mat-icon>
                    </button>
                </div>
                <div class="w-full p-4">
                    <!-- CEP -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">CEP</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(billingAddress?.zipCode) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Endereço -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Endereço</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(billingAddress?.address) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Bairro -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Bairro</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(billingAddress?.neighborhood) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Cidade/Estado -->
                    <div class="py-4 border-b border-gray-100">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">Cidade/Estado</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ formattedCityState }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- País -->
                    <div class="py-4">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="text-[13px] font-inter font-[400] text-gray-500 block mb-1">País</span>
                                <span class="text-[14px] font-inter font-[500] text-gray-900">{{ getDisplayValue(billingAddress?.country) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
